module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e1379246"
    }
  }, [_c('b', [_vm._v("BUFFALO-STYLE CHICKEN WINGS")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e1379746"
    }
  }, [_c('b', [_c('i', [_vm._v("Here’s a broiled version of one of America’s favorite appetizers. Serve with plenty of napkins!")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1380746"
    }
  }, [_c('b', [_vm._v("Prep: 15 minutes     Broil: 20 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1381346"
    }
  }, [_vm._v("4 ounces blue cheese, crumbled (1 cup)")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1381646"
    }
  }, [_vm._v("½ cup sour cream")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1382546"
    }
  }, [_vm._v("¼ cup mayonnaise")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1383546"
    }
  }, [_vm._v("¼ cup milk")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1384446"
    }
  }, [_vm._v("¼ cup chopped fresh parsley")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1385446"
    }
  }, [_vm._v("1 tablespoon fresh lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1385746"
    }
  }, [_vm._v("½ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1386646"
    }
  }, [_vm._v("3 pounds chicken wings (18 wings), tips discarded, "), _c('br'), _vm._v(" if desired")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1387346"
    }
  }, [_vm._v("3 tablespoons butter or margarine")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1387646"
    }
  }, [_vm._v("¼ cup hot pepper sauce")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1388546"
    }
  }, [_vm._v("1 medium bunch celery, cut into sticks")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e1389046"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Preheat broiler. In medium bowl, combine blue cheese, sour cream, mayonnaise, milk, parsley, lemon juice, and ¼ teaspoon salt. Cover and refrigerate.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1391246"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Arrange chicken wings on rack in broiling pan; sprinkle with remaining ¼ teaspoon salt. Broil 5 inches from heat source 10 minutes. Turn wings and broil until golden, 10 to 15 minutes longer.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1393746"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Meanwhile, in small saucepan, melt butter with hot pepper sauce over low heat, stirring occasionally; keep hot.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1395146"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" In large bowl, toss wings with seasoned butter to coat all sides. Arrange chicken wings and celery on platter along with blue-cheese sauce and serve. Makes 18 appetizers.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1397046"
    }
  }, [_vm._v("Each appetizer (without wing tip) : About 169 calories, 10g protein, 3g carbohydrate, 13g total fat (5g saturated), 39mg cholesterol, 349mg sodium.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8500008","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c38_r1.vue
// module id = 180
// module chunks = 0